import gql from 'graphql-tag'

export const GET_PLAYBOOK_SETTINGS_Q = gql`
  query ScGetPlaybookSettings($workspaceId: String!) {
    playbookSettings(workspaceId: $workspaceId) {
      workspaceId
      minimumDwellTime
    }
  }
`

export const GET_CONDITIONAL_CONTENTS_Q = gql`
  query ScGetConditionalContents($workspaceId: String!) {
    conditionalContents(queryConditionalContentsInput: { workspaceId: $workspaceId }) {
      items {
        id
        name
        isActive
        workspaceId
        displayIds
        startDate
        endDate
        isEveryDay
        daysOfTheWeek
        createdAt
        priority
        presentationId
        conditionManagementId
        prebuiltKind
        conditions {
          key
          value {
            vehicleBrand
            vehicleType
            licensePlates
            vehicleListIds
            cameraSourceDeviceIds
            licensePlateStates
            vehicleModels
            vehicleColors
            weatherConditions
            temperatureThresholdF
            operator
          }
        }
      }
      pagination {
        totalCount
        offset
        limit
      }
    }
  }
`

// RD-7447 — standalone async lookup for the Active Plays "Times
// Triggered" column; fired separately from the plays list so a slow
// ClickHouse never blocks the table. Counts are shared across plays
// with identical conditions — dedupe by conditionsKey before summing.
export const GET_CONDITIONAL_CONTENT_TRIGGERED_TIMES_Q = gql`
  query ScGetConditionalContentTriggeredTimes($workspaceId: String!) {
    conditionalContentTriggeredTimes(workspaceId: $workspaceId) {
      conditionalContentId
      conditionsKey
      triggeredTimes
    }
  }
`

export const GET_CONDITIONAL_CONTENTS_BY_DISPLAY_ID_Q = gql`
  query getConditionalContentsByDisplayId($display: String!) {
    getConditionalContentsByDisplayId(displayId: $display) {
      name
    }
  }
`
